import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Time: string;
};

export type AvFileProcess = {
  __typename: 'AVFileProcess';
  errors?: Maybe<FileProcessErrors>;
  name: Scalars['String'];
  virusStatus: VirusStatus;
};

export type AvFileProcessErrorsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type AddUserInput = {
  email: Scalars['String'];
  emailNotifications: Array<Scalars['String']>;
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
};

export type AppConfig = {
  __typename: 'AppConfig';
  canDownloadPiiReport: Scalars['Boolean'];
  canManageUsers: Scalars['Boolean'];
  canViewProblemFiles: Scalars['Boolean'];
  version: Scalars['String'];
};

export type ApprovalInputById = {
  comment: Scalars['String'];
  id: Scalars['ID'];
};

export type Breadcrumb = {
  __typename: 'Breadcrumb';
  directoryId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CedantDetails = {
  __typename: 'CedantDetails';
  activityFilterOptions: ActivityFilterOptions;
  canCreate: Scalars['Boolean'];
  cedant: Scalars['String'];
  cleanupDirectory: CleanupReport;
  directory: Directory;
  downloadFile: Scalars['String'];
  events: EventsResponse;
  fileById: File;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ActivityFilterOptions = {
  __typename: 'ActivityFilterOptions';
  paths: Array<Scalars['String']>;
  users: Array<FilterUserOption>;
};

export type CedantDetailsCleanupDirectoryArgs = {
  days: Scalars['Int'];
  id: Scalars['ID'];
};

export type CedantDetailsDirectoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type CedantDetailsDownloadFileArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};

export type CedantDetailsEventsArgs = {
  cursorPagination?: InputMaybe<CursorPagination>;
  file?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<EventType>>;
  user?: InputMaybe<Scalars['String']>;
};

export type CedantDetailsFileByIdArgs = {
  id: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};

export type CleanupReport = {
  __typename: 'CleanupReport';
  code: CleanupStatus;
};

export enum CleanupStatus {
  ERROR = 'ERROR',
  PROCESSED = 'PROCESSED',
}

export type CreateFolderInput = {
  /** Full path to the folder to be created ending in a / */
  directory: Scalars['String'];
};

export type CursorPagination = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};



export type DataRoomCategory = {
  __typename: 'DataRoomCategory';
  dataRooms: DataRooms;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DataRoomCategoryDataRoomsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type DataRooms = {
  __typename: 'DataRooms';
  count: Scalars['Int'];
  objects: Array<CedantDetails>;
};

export type Directory = {
  __typename: 'Directory';
  breadcrumbs: Array<Breadcrumb>;
  canArchive: Scalars['Boolean'];
  cedant: Scalars['String'];
  directoryCount: Scalars['Int'];
  fileCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  objects: StorageObjects;
  parentDirectoryId: Scalars['String'];
  path: Scalars['String'];
};

export type DirectoryObjectsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type ErrorMessage = {
  __typename: 'ErrorMessage';
  column?: Maybe<Scalars['String']>;
  errType?: Maybe<Scalars['String']>;
  raw: Scalars['String'];
  row?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename: 'Event';
  id: Scalars['ID'];
  path: Scalars['String'];
  storageObject: StorageObject;
  timestamp: Scalars['Time'];
  type: EventType;
  user: User;
};

export enum EventType {
  FILE_ARCHIVED = 'FILE_ARCHIVED',
  FILE_CREATED = 'FILE_CREATED',
  FILE_DELETED = 'FILE_DELETED',
  FILE_DOWNLOADED = 'FILE_DOWNLOADED',
  FILE_MOVED = 'FILE_MOVED',
  FILE_RENAMED = 'FILE_RENAMED',
  FILE_UPDATED = 'FILE_UPDATED',
  FOLDER_CREATED = 'FOLDER_CREATED',
  FOLDER_DOWNLOADED = 'FOLDER_DOWNLOADED',
  PII_APPROVED = 'PII_APPROVED',
}

export type EventsResponse = {
  __typename: 'EventsResponse';
  events: Array<Event>;
  hasMore: Scalars['Boolean'];
};

export type File = {
  __typename: 'File';
  archivedAt?: Maybe<Scalars['Time']>;
  archivedBy?: Maybe<User>;
  automatedUpload: Scalars['Boolean'];
  breadcrumbs: Array<Breadcrumb>;
  canArchive: Scalars['Boolean'];
  canDelete: Scalars['Boolean'];
  canDownload: Scalars['Boolean'];
  canMove: Scalars['Boolean'];
  canPiiApprove: Scalars['Boolean'];
  canPiiJustify: Scalars['Boolean'];
  canRead: Scalars['Boolean'];
  canRename: Scalars['Boolean'];
  canRetryProcesses: Scalars['Boolean'];
  cedant: Scalars['String'];
  contentType: Scalars['String'];
  createdAt?: Maybe<Scalars['Time']>;
  createdBy?: Maybe<User>;
  fileTypeCheckDetails?: Maybe<FileTypeCheckDetails>;
  fileTypeCheckStatus: FileTypeCheckStatus;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentDirectoryId: Scalars['String'];
  path: Scalars['String'];
  piiDetails?: Maybe<PiiDetails>;
  piiStatus?: Maybe<PiiStatus>;
  processes: Array<FileProcess>;
  size: Scalars['Int'];
  status?: Maybe<FileStatus>;
  transformation?: Maybe<Transformation>;
  updatedAt: Scalars['Time'];
  updatedBy?: Maybe<User>;
  version?: Maybe<Scalars['String']>;
  versions: Array<File>;
  virusStatus?: Maybe<VirusStatus>;
};

export type FileProcess = AvFileProcess | GenericFileProcess | PiiFileProcess;

export type FileProcessError = {
  __typename: 'FileProcessError';
  code: FileProcessErrorCode;
  message?: Maybe<Scalars['String']>;
};

export enum FileProcessErrorCode {
  FILE = 'FILE',
  UNKNOWN = 'UNKNOWN',
  VALUE = 'VALUE',
}

export type FileProcessErrors = {
  __typename: 'FileProcessErrors';
  count: Scalars['Int'];
  errors: Array<FileProcessError>;
};

export enum FileProcessStatus {
  DONE = 'DONE',
  PROCESSING = 'PROCESSING',
}

export enum FileStatus {
  AWAITING_UPLOAD = 'AWAITING_UPLOAD',
  ERROR = 'ERROR',
  PROCESSED = 'PROCESSED',
  PROCESSING = 'PROCESSING',
  UPLOADED = 'UPLOADED',
}

export type FileTypeCheckDetails = {
  __typename: 'FileTypeCheckDetails';
  detectedFileType: Scalars['String'];
  result: Scalars['String'];
};

export enum FileTypeCheckStatus {
  SUPPORTED = 'SUPPORTED',
  UNSUPPORTED = 'UNSUPPORTED',
}

export type FileUploadSignedUrlInput = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};

export type GenericFileProcess = {
  __typename: 'GenericFileProcess';
  errors?: Maybe<FileProcessErrors>;
  name: Scalars['String'];
  status: FileProcessStatus;
};

export type GenericFileProcessErrorsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type Header = {
  __typename: 'Header';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MoveFileInput = {
  destinationDirectoryID: Scalars['ID'];
  fileID: Scalars['ID'];
};

export type Mutation = {
  __typename: 'Mutation';
  addUser: TreatyUser;
  archiveDirectory: Scalars['Boolean'];
  archiveFileById: File;
  blockUser: Scalars['Boolean'];
  createFolder: Directory;
  deleteFileById: File;
  moveFile: File;
  piiApproveById: File;
  piiJustifyById: File;
  renameFile: File;
  resetMFA: Scalars['Boolean'];
  retryFileProcesses: Scalars['Boolean'];
  unblockUser: Scalars['Boolean'];
  updateUserEmailNotifications: Scalars['Boolean'];
  updateUserRoles: Scalars['Boolean'];
  uploadFileSignedURL: UploadSignedUrl;
  validateFilenames: Array<ValidatedFilename>;
};

export type MutationAddUserArgs = {
  input: AddUserInput;
};

export type MutationArchiveDirectoryArgs = {
  cedant: Scalars['String'];
  directoryId: Scalars['ID'];
};

export type MutationArchiveFileByIdArgs = {
  cedant: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationBlockUserArgs = {
  userId: Scalars['ID'];
};

export type MutationCreateFolderArgs = {
  cedant: Scalars['String'];
  input: CreateFolderInput;
};

export type MutationDeleteFileByIdArgs = {
  cedant: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationMoveFileArgs = {
  cedant: Scalars['String'];
  input: MoveFileInput;
};

export type MutationPiiApproveByIdArgs = {
  cedant: Scalars['String'];
  input: ApprovalInputById;
};

export type MutationPiiJustifyByIdArgs = {
  cedant: Scalars['String'];
  input: ApprovalInputById;
};

export type MutationRenameFileArgs = {
  cedant: Scalars['String'];
  input: RenameFileInput;
};

export type MutationResetMfaArgs = {
  userId: Scalars['ID'];
};

export type MutationRetryFileProcessesArgs = {
  fileId: Scalars['ID'];
};

export type MutationUnblockUserArgs = {
  userId: Scalars['ID'];
};

export type MutationUpdateUserEmailNotificationsArgs = {
  input?: InputMaybe<UpdateUserEmailNotificationsInput>;
};

export type MutationUpdateUserRolesArgs = {
  input: UpdateUserRolesInput;
};

export type MutationUploadFileSignedUrlArgs = {
  cedant: Scalars['String'];
  input: FileUploadSignedUrlInput;
};

export type MutationValidateFilenamesArgs = {
  cedant: Scalars['String'];
  input: ValidateFilenamesInput;
};

export enum Operation {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  SET = 'SET',
}

export type PiiApproval = {
  __typename: 'PIIApproval';
  approvedAt: Scalars['Time'];
  approver: User;
  comment: Scalars['String'];
  type?: Maybe<PiiApprovalType>;
};

export enum PiiApprovalType {
  CEDANT = 'CEDANT',
  RESRE = 'RESRE',
}

export type PiiDetails = {
  __typename: 'PIIDetails';
  approvals: Array<PiiApproval>;
  matches: Array<PiiMatch>;
};

export type PiiFileProcess = {
  __typename: 'PIIFileProcess';
  errors?: Maybe<FileProcessErrors>;
  name: Scalars['String'];
  piiStatus: PiiStatus;
};

export type PiiFileProcessErrorsArgs = {
  pagination?: InputMaybe<Pagination>;
};

export type PiiInfo = {
  __typename: 'PIIInfo';
  label: Scalars['String'];
  type: PiiInfoType;
};

export enum PiiInfoType {
  ADVERTISING_ID = 'ADVERTISING_ID',
  CREDIT_CARD_NUMBER = 'CREDIT_CARD_NUMBER',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  FIRST_NAME = 'FIRST_NAME',
  GENERIC_ID = 'GENERIC_ID',
  HTTP_COOKIE = 'HTTP_COOKIE',
  IBAN_CODE = 'IBAN_CODE',
  ICD9_CODE = 'ICD9_CODE',
  ICD10_CODE = 'ICD10_CODE',
  IMEI_HARDWARE_ID = 'IMEI_HARDWARE_ID',
  IP_ADDRESS = 'IP_ADDRESS',
  LAST_NAME = 'LAST_NAME',
  LOCATION = 'LOCATION',
  MAC_ADDRESS = 'MAC_ADDRESS',
  PASSPORT = 'PASSPORT',
  PASSWORD = 'PASSWORD',
  PERSON_NAME = 'PERSON_NAME',
  PHONE_NUMBER = 'PHONE_NUMBER',
  STREET_ADDRESS = 'STREET_ADDRESS',
  US_BANK_ROUTING_MICR = 'US_BANK_ROUTING_MICR',
  US_DRIVERS_LICENSE_NUMBER = 'US_DRIVERS_LICENSE_NUMBER',
  US_EMPLOYER_IDENTIFICATION_NUMBER = 'US_EMPLOYER_IDENTIFICATION_NUMBER',
  US_HEALTHCARE_NPI = 'US_HEALTHCARE_NPI',
  US_INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER = 'US_INDIVIDUAL_TAXPAYER_IDENTIFICATION_NUMBER',
  US_PREPARER_TAXPAYER_IDENTIFICATION_NUMBER = 'US_PREPARER_TAXPAYER_IDENTIFICATION_NUMBER',
  US_SOCIAL_SECURITY_NUMBER = 'US_SOCIAL_SECURITY_NUMBER',
  VEHICLE_IDENTIFICATION_NUMBER = 'VEHICLE_IDENTIFICATION_NUMBER',
}

export type PiiMatch = {
  __typename: 'PIIMatch';
  count: Scalars['Int'];
  infoType: PiiInfo;
};

export enum PiiStatus {
  APPROVED = 'APPROVED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  EXCLUDED_FOLDER = 'EXCLUDED_FOLDER',
  EXCLUDED_USER = 'EXCLUDED_USER',
  SCANNING = 'SCANNING',
  UNSUPPORTED = 'UNSUPPORTED',
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProblematicFiles = {
  __typename: 'ProblematicFiles';
  count: Scalars['Int'];
  files: Array<File>;
  problemDescription: Scalars['String'];
  problemType: Scalars['String'];
};

export type ProblematicFilesObject = {
  __typename: 'ProblematicFilesObject';
  allowedDataRooms: Array<CedantDetails>;
  problematicFiles: Array<ProblematicFiles>;
};

export type Query = {
  __typename: 'Query';
  appConfig: AppConfig;
  cedant?: Maybe<CedantDetails>;
  dataRoomCategories: Array<DataRoomCategory>;
  me: User;
  problematicFiles: ProblematicFilesObject;
  role: Role;
  roles: Array<Role>;
  search: StorageObjects;
  treatyUser?: Maybe<TreatyUser>;
  treatyUsers: TreatyUsers;
};

export type QueryCedantArgs = {
  cedant: Scalars['String'];
};

export type QueryProblematicFilesArgs = {
  cedants?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryRoleArgs = {
  id: Scalars['ID'];
};

export type QuerySearchArgs = {
  cedants?: InputMaybe<Array<Scalars['String']>>;
  from?: InputMaybe<Scalars['Time']>;
  pagination?: InputMaybe<Pagination>;
  term: Scalars['String'];
  to?: InputMaybe<Scalars['Time']>;
};

export type QueryTreatyUserArgs = {
  id: Scalars['ID'];
};

export type QueryTreatyUsersArgs = {
  searchParams: TreatyUsersSearch;
};

export type RenameFileInput = {
  fileID: Scalars['ID'];
  newFileName: Scalars['String'];
};

export type Role = {
  __typename: 'Role';
  id: Scalars['ID'];
  rawPermissions: Scalars['String'];
};

export type StorageObject = Directory | File;

export type StorageObjects = {
  __typename: 'StorageObjects';
  count: Scalars['Int'];
  objects: Array<StorageObject>;
};

export type Transformation = {
  __typename: 'Transformation';
  errors?: Maybe<TransformationErrors>;
  transformedAt?: Maybe<Scalars['Time']>;
};

export enum TransformationErrorCode {
  INVALID_FIELDS = 'INVALID_FIELDS',
  INVALID_FILE = 'INVALID_FILE',
}

export type TransformationErrors = {
  __typename: 'TransformationErrors';
  code: TransformationErrorCode;
  messages: Array<ErrorMessage>;
};

export type TreatyUser = {
  __typename: 'TreatyUser';
  canBlock: Scalars['Boolean'];
  createdAt: Scalars['Time'];
  email: Scalars['String'];
  emailNotifications: Array<Scalars['String']>;
  hasMFAEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  isBlocked: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['Time']>;
  loginCount: Scalars['Int'];
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
  tenant: Scalars['String'];
  type: UserType;
};

export type TreatyUsers = {
  __typename: 'TreatyUsers';
  count: Scalars['Int'];
  users: Array<TreatyUser>;
};

export type TreatyUsersSearch = {
  includeBlocked?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pagination: Pagination;
  roles?: InputMaybe<Array<Scalars['String']>>;
  userType?: InputMaybe<UserType>;
};

export type UpdateUserEmailNotificationsInput = {
  cedants: Array<Scalars['String']>;
  op: Operation;
  userId: Scalars['ID'];
};

export type UpdateUserRolesInput = {
  op: Operation;
  roles: Array<Scalars['String']>;
  userId: Scalars['ID'];
};

export type UploadSignedUrl = {
  __typename: 'UploadSignedURL';
  fileID: Scalars['ID'];
  fileVersionID: Scalars['ID'];
  headers: Array<Header>;
  parentDirectoryID: Scalars['ID'];
  signedURL: Scalars['String'];
};

export type User = {
  __typename: 'User';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  machineUser: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export enum UserType {
  EXTERNAL_USER = 'EXTERNAL_USER',
  INTERNAL_USER = 'INTERNAL_USER',
}

export type ValidateFilenamesInput = {
  files: Array<ValidateFilesInput>;
};

export type ValidateFilesInput = {
  directory?: InputMaybe<Scalars['String']>;
  filepath: Scalars['String'];
  id: Scalars['ID'];
  isDirectory?: InputMaybe<Scalars['Boolean']>;
};

export type ValidatedFilename = {
  __typename: 'ValidatedFilename';
  errors?: Maybe<Array<ValidatedFilenameError>>;
  filepath: Scalars['String'];
  id: Scalars['ID'];
  isValid: Scalars['Boolean'];
  warnings?: Maybe<Array<ValidatedFilenameWarning>>;
};

export type ValidatedFilenameError = {
  __typename: 'ValidatedFilenameError';
  code: ValidatedFilenameErrorCode;
  suggestedFilename?: Maybe<Scalars['String']>;
  suggestedFilepath?: Maybe<Scalars['String']>;
};

export enum ValidatedFilenameErrorCode {
  FILENAME_LENGTH_LIMIT = 'FILENAME_LENGTH_LIMIT',
  INVALID_CHARACTERS = 'INVALID_CHARACTERS',
  UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE',
}

export type ValidatedFilenameWarning = {
  __typename: 'ValidatedFilenameWarning';
  code: ValidatedFilenameWarningCode;
  expectedPattern?: Maybe<Scalars['String']>;
  expectedPatterns?: Maybe<Array<Scalars['String']>>;
  message?: Maybe<Scalars['String']>;
};

export enum ValidatedFilenameWarningCode {
  FILENAME_PATTERN_MISMATCH = 'FILENAME_PATTERN_MISMATCH',
}

export enum VirusStatus {
  CLEAN = 'CLEAN',
  QUARANTINED = 'QUARANTINED',
  SCANNING = 'SCANNING',
  UNSUPPORTED = 'UNSUPPORTED',
}

export type AddUserMutationVariables = Exact<{
  input: AddUserInput;
}>;

export type AddUserMutation = {
  __typename: 'Mutation';
  addUser: { __typename: 'TreatyUser'; id: string; name: string };
};

export type EventFileFragment = {
  __typename: 'File';
  id: string;
  name: string;
  path: string;
  parentDirectoryId: string;
};

export type EventDirectoryFragment = {
  __typename: 'Directory';
  id: string;
  name: string;
  path: string;
  parentDirectoryId: string;
};

export type EventFragment = {
  __typename: 'Event';
  id: string;
  type: EventType;
  timestamp: string;
  path: string;
  user: {
    __typename: 'User';
    id: string;
    email?: string | null;
    name?: string | null;
  };
  storageObject:
    | {
        __typename: 'Directory';
        id: string;
        name: string;
        path: string;
        parentDirectoryId: string;
      }
    | {
        __typename: 'File';
        id: string;
        name: string;
        path: string;
        parentDirectoryId: string;
      };
};

export type EventsResponseFragment = {
  __typename: 'EventsResponse';
  hasMore: boolean;
  events: Array<{
    __typename: 'Event';
    id: string;
    type: EventType;
    timestamp: string;
    path: string;
    user: {
      __typename: 'User';
      id: string;
      email?: string | null;
      name?: string | null;
    };
    storageObject:
      | {
          __typename: 'Directory';
          id: string;
          name: string;
          path: string;
          parentDirectoryId: string;
        }
      | {
          __typename: 'File';
          id: string;
          name: string;
          path: string;
          parentDirectoryId: string;
        };
  }>;
};

export type GetFileActivityEventsQueryVariables = Exact<{
  cedant: Scalars['String'];
  eventTypes?: InputMaybe<Array<EventType> | EventType>;
  user?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<CursorPagination>;
}>;

export type GetFileActivityEventsQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    name: string;
    events: {
      __typename: 'EventsResponse';
      hasMore: boolean;
      events: Array<{
        __typename: 'Event';
        id: string;
        type: EventType;
        timestamp: string;
        path: string;
        user: {
          __typename: 'User';
          id: string;
          email?: string | null;
          name?: string | null;
        };
        storageObject:
          | {
              __typename: 'Directory';
              id: string;
              name: string;
              path: string;
              parentDirectoryId: string;
            }
          | {
              __typename: 'File';
              id: string;
              name: string;
              path: string;
              parentDirectoryId: string;
            };
      }>;
    };
  } | null;
};

export type GetActivityFilterOptionsQueryVariables = Exact<{
  cedant: Scalars['String'];
}>;

export type GetActivityFilterOptionsQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    name: string;
    activityFilterOptions: {
      __typename: 'ActivityFilterOptions';
      paths: Array<string>;
      users: Array<{
        __typename: 'FilterUserOption';
        id: string;
        name: string;
      }>;
    };
  } | null;
};

export type ArchiveDirectoryMutationVariables = Exact<{
  cedant: Scalars['String'];
  directoryId: Scalars['ID'];
}>;

export type ArchiveDirectoryMutation = {
  __typename: 'Mutation';
  archiveDirectory: boolean;
};

export type ArchiveFileByIdMutationVariables = Exact<{
  cedant: Scalars['String'];
  id: Scalars['ID'];
}>;

export type ArchiveFileByIdMutation = {
  __typename: 'Mutation';
  archiveFileById: { __typename: 'File'; id: string; name: string };
};

export type DeleteFileByIdMutationVariables = Exact<{
  cedant: Scalars['String'];
  id: Scalars['ID'];
}>;

export type DeleteFileByIdMutation = {
  __typename: 'Mutation';
  deleteFileById: { __typename: 'File'; id: string; name: string };
};

export type MoveFileMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: MoveFileInput;
}>;

export type MoveFileMutation = {
  __typename: 'Mutation';
  moveFile: {
    __typename: 'File';
    id: string;
    cedant: string;
    name: string;
    path: string;
  };
};

export type FileMoveFileFragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  path: string;
};

export type FileMoveDirectoryFragment = {
  __typename: 'Directory';
  id: string;
  name: string;
  cedant: string;
  path: string;
};

export type GetFileMoveDirectoryQueryVariables = Exact<{
  cedant: Scalars['String'];
  directoryId?: InputMaybe<Scalars['ID']>;
  objectsPagination?: InputMaybe<Pagination>;
}>;

export type GetFileMoveDirectoryQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    name: string;
    directory: {
      __typename: 'Directory';
      id: string;
      name: string;
      cedant: string;
      path: string;
      breadcrumbs: Array<{
        __typename: 'Breadcrumb';
        name: string;
        directoryId?: string | null;
      }>;
      objects: {
        __typename: 'StorageObjects';
        objects: Array<
          | {
              __typename: 'Directory';
              id: string;
              name: string;
              cedant: string;
              path: string;
            }
          | {
              __typename: 'File';
              id: string;
              name: string;
              cedant: string;
              path: string;
            }
        >;
      };
    };
  } | null;
};

export type RenameFileMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: RenameFileInput;
}>;

export type RenameFileMutation = {
  __typename: 'Mutation';
  renameFile: {
    __typename: 'File';
    id: string;
    cedant: string;
    name: string;
    path: string;
  };
};

export type PiiApproveByIdMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: ApprovalInputById;
}>;

export type PiiApproveByIdMutation = {
  __typename: 'Mutation';
  piiApproveById: {
    __typename: 'File';
    id: string;
    status?: FileStatus | null;
    piiStatus?: PiiStatus | null;
    piiDetails?: {
      __typename: 'PIIDetails';
      approvals: Array<{
        __typename: 'PIIApproval';
        approver: { __typename: 'User'; name?: string | null };
      }>;
    } | null;
  };
};

export type PiiJustifyByIdMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: ApprovalInputById;
}>;

export type PiiJustifyByIdMutation = {
  __typename: 'Mutation';
  piiJustifyById: {
    __typename: 'File';
    id: string;
    status?: FileStatus | null;
    piiStatus?: PiiStatus | null;
    piiDetails?: {
      __typename: 'PIIDetails';
      approvals: Array<{
        __typename: 'PIIApproval';
        approver: { __typename: 'User'; name?: string | null };
      }>;
    } | null;
  };
};

export type DownloadFileQueryVariables = Exact<{
  cedant: Scalars['String'];
  fileId: Scalars['ID'];
}>;

export type DownloadFileQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    signedUrl: string;
  } | null;
};

export type MeFragment = { __typename: 'User'; name?: string | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never }>;

export type GetMeQuery = {
  __typename: 'Query';
  me: { __typename: 'User'; name?: string | null };
};

export type RetryFileProcessesMutationVariables = Exact<{
  fileId: Scalars['ID'];
}>;

export type RetryFileProcessesMutation = {
  __typename: 'Mutation';
  retryFileProcesses: boolean;
};

export type DownloadFileVersionQueryVariables = Exact<{
  cedant: Scalars['String'];
  fileId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
}>;

export type DownloadFileVersionQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    signedUrl: string;
  } | null;
};

export type VersionHistoryFileFieldsFragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  path: string;
  parentDirectoryId: string;
  size: number;
  updatedAt: string;
  createdAt?: string | null;
  status?: FileStatus | null;
  piiStatus?: PiiStatus | null;
  virusStatus?: VirusStatus | null;
  version?: string | null;
  canDownload: boolean;
  canMove: boolean;
  contentType: string;
  versions: Array<{ __typename: 'File'; id: string }>;
  breadcrumbs: Array<{
    __typename: 'Breadcrumb';
    name: string;
    directoryId?: string | null;
  }>;
  createdBy?: { __typename: 'User'; id: string; name?: string | null } | null;
  updatedBy?: { __typename: 'User'; id: string; name?: string | null } | null;
};

export type FileVersionHistoryFragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  path: string;
  parentDirectoryId: string;
  size: number;
  updatedAt: string;
  createdAt?: string | null;
  status?: FileStatus | null;
  piiStatus?: PiiStatus | null;
  virusStatus?: VirusStatus | null;
  version?: string | null;
  canDownload: boolean;
  canMove: boolean;
  contentType: string;
  versions: Array<{
    __typename: 'File';
    id: string;
    name: string;
    cedant: string;
    path: string;
    parentDirectoryId: string;
    size: number;
    updatedAt: string;
    createdAt?: string | null;
    status?: FileStatus | null;
    piiStatus?: PiiStatus | null;
    virusStatus?: VirusStatus | null;
    version?: string | null;
    canDownload: boolean;
    canMove: boolean;
    contentType: string;
    versions: Array<{ __typename: 'File'; id: string }>;
    breadcrumbs: Array<{
      __typename: 'Breadcrumb';
      name: string;
      directoryId?: string | null;
    }>;
    createdBy?: { __typename: 'User'; id: string; name?: string | null } | null;
    updatedBy?: { __typename: 'User'; id: string; name?: string | null } | null;
  }>;
  breadcrumbs: Array<{
    __typename: 'Breadcrumb';
    name: string;
    directoryId?: string | null;
  }>;
  createdBy?: { __typename: 'User'; id: string; name?: string | null } | null;
  updatedBy?: { __typename: 'User'; id: string; name?: string | null } | null;
};

export type GetFileVersionHistoryQueryVariables = Exact<{
  cedant: Scalars['String'];
  fileId: Scalars['ID'];
}>;

export type GetFileVersionHistoryQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    file: {
      __typename: 'File';
      id: string;
      name: string;
      cedant: string;
      path: string;
      parentDirectoryId: string;
      size: number;
      updatedAt: string;
      createdAt?: string | null;
      status?: FileStatus | null;
      piiStatus?: PiiStatus | null;
      virusStatus?: VirusStatus | null;
      version?: string | null;
      canDownload: boolean;
      canMove: boolean;
      contentType: string;
      versions: Array<{
        __typename: 'File';
        id: string;
        name: string;
        cedant: string;
        path: string;
        parentDirectoryId: string;
        size: number;
        updatedAt: string;
        createdAt?: string | null;
        status?: FileStatus | null;
        piiStatus?: PiiStatus | null;
        virusStatus?: VirusStatus | null;
        version?: string | null;
        canDownload: boolean;
        canMove: boolean;
        contentType: string;
        versions: Array<{ __typename: 'File'; id: string }>;
        breadcrumbs: Array<{
          __typename: 'Breadcrumb';
          name: string;
          directoryId?: string | null;
        }>;
        createdBy?: {
          __typename: 'User';
          id: string;
          name?: string | null;
        } | null;
        updatedBy?: {
          __typename: 'User';
          id: string;
          name?: string | null;
        } | null;
      }>;
      breadcrumbs: Array<{
        __typename: 'Breadcrumb';
        name: string;
        directoryId?: string | null;
      }>;
      createdBy?: {
        __typename: 'User';
        id: string;
        name?: string | null;
      } | null;
      updatedBy?: {
        __typename: 'User';
        id: string;
        name?: string | null;
      } | null;
    };
  } | null;
};

export type GetSearchResultsQueryVariables = Exact<{
  cedants?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  term: Scalars['String'];
  pagination?: InputMaybe<Pagination>;
  from?: InputMaybe<Scalars['Time']>;
  to?: InputMaybe<Scalars['Time']>;
}>;

export type GetSearchResultsQuery = {
  __typename: 'Query';
  search: {
    __typename: 'StorageObjects';
    count: number;
    objects: Array<
      | {
          __typename: 'Directory';
          id: string;
          name: string;
          cedant: string;
          path: string;
          fileCount: number;
          directoryCount: number;
          canArchive: boolean;
        }
      | {
          __typename: 'File';
          id: string;
          name: string;
          cedant: string;
          path: string;
          parentDirectoryId: string;
          size: number;
          updatedAt: string;
          createdAt?: string | null;
          status?: FileStatus | null;
          virusStatus?: VirusStatus | null;
          piiStatus?: PiiStatus | null;
          canDownload: boolean;
          canMove: boolean;
          contentType: string;
          breadcrumbs: Array<{
            __typename: 'Breadcrumb';
            name: string;
            directoryId?: string | null;
          }>;
          versions: Array<{ __typename: 'File'; id: string }>;
        }
    >;
  };
};

export type ResetMfaMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type ResetMfaMutation = { __typename: 'Mutation'; resetMFA: boolean };

export type UpdateUserEmailNotificationsMutationVariables = Exact<{
  input: UpdateUserEmailNotificationsInput;
}>;

export type UpdateUserEmailNotificationsMutation = {
  __typename: 'Mutation';
  updateUserEmailNotifications: boolean;
};

export type UpdateUserRolesMutationVariables = Exact<{
  input: UpdateUserRolesInput;
}>;

export type UpdateUserRolesMutation = {
  __typename: 'Mutation';
  updateUserRoles: boolean;
};

export type TreatyUserDetailFragment = {
  __typename: 'TreatyUser';
  hasMFAEnabled: boolean;
  id: string;
  canBlock: boolean;
  createdAt: string;
  email: string;
  emailNotifications: Array<string>;
  isBlocked: boolean;
  lastLogin?: string | null;
  loginCount: number;
  name: string;
  roles: Array<string>;
  type: UserType;
};

export type GetTreatyUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTreatyUserQuery = {
  __typename: 'Query';
  treatyUser?: {
    __typename: 'TreatyUser';
    hasMFAEnabled: boolean;
    id: string;
    canBlock: boolean;
    createdAt: string;
    email: string;
    emailNotifications: Array<string>;
    isBlocked: boolean;
    lastLogin?: string | null;
    loginCount: number;
    name: string;
    roles: Array<string>;
    type: UserType;
  } | null;
};

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type BlockUserMutation = { __typename: 'Mutation'; blockUser: boolean };

export type UnblockUserMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type UnblockUserMutation = {
  __typename: 'Mutation';
  unblockUser: boolean;
};

export type CreateFolderMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: CreateFolderInput;
}>;

export type CreateFolderMutation = {
  __typename: 'Mutation';
  createFolder: {
    __typename: 'Directory';
    id: string;
    name: string;
    cedant: string;
    path: string;
    fileCount: number;
    directoryCount: number;
    canArchive: boolean;
  };
};

export type UploadFileSignedUrlMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: FileUploadSignedUrlInput;
}>;

export type UploadFileSignedUrlMutation = {
  __typename: 'Mutation';
  uploadFileSignedURL: {
    __typename: 'UploadSignedURL';
    signedURL: string;
    headers: Array<{ __typename: 'Header'; key: string; value: string }>;
  };
};

export type ValidatedFilenameErrorFragment = {
  __typename: 'ValidatedFilenameError';
  code: ValidatedFilenameErrorCode;
  suggestedFilename?: string | null;
  suggestedFilepath?: string | null;
};

export type ValidatedFilenameWarningFragment = {
  __typename: 'ValidatedFilenameWarning';
  code: ValidatedFilenameWarningCode;
  expectedPattern?: string | null;
  expectedPatterns?: Array<string> | null;
  message?: string | null;
};

export type ValidatedFilenameFragment = {
  __typename: 'ValidatedFilename';
  id: string;
  filepath: string;
  isValid: boolean;
};

export type ValidateFilenamesMutationVariables = Exact<{
  cedant: Scalars['String'];
  input: ValidateFilenamesInput;
}>;

export type ValidateFilenamesMutation = {
  __typename: 'Mutation';
  validateFilenames: Array<{
    __typename: 'ValidatedFilename';
    id: string;
    filepath: string;
    isValid: boolean;
    errors?: Array<{
      __typename: 'ValidatedFilenameError';
      code: ValidatedFilenameErrorCode;
      suggestedFilename?: string | null;
      suggestedFilepath?: string | null;
    }> | null;
    warnings?: Array<{
      __typename: 'ValidatedFilenameWarning';
      code: ValidatedFilenameWarningCode;
      expectedPattern?: string | null;
      expectedPatterns?: Array<string> | null;
      message?: string | null;
    }> | null;
  }>;
};

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never }>;

export type GetAppConfigQuery = {
  __typename: 'Query';
  appConfig: {
    __typename: 'AppConfig';
    canManageUsers: boolean;
    canDownloadPiiReport: boolean;
    canViewProblemFiles: boolean;
  };
};

export type GetTreatyNameQueryVariables = Exact<{
  cedant: Scalars['String'];
}>;

export type GetTreatyNameQuery = {
  __typename: 'Query';
  treaty?: { __typename: 'CedantDetails'; id: string; name: string } | null;
};

export type DataRoomObjectFragment = {
  __typename: 'CedantDetails';
  id: string;
  cedant: string;
  name: string;
};

export type GetDataRoomsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDataRoomsQuery = {
  __typename: 'Query';
  dataRoomCategories: Array<{
    __typename: 'DataRoomCategory';
    id: string;
    name: string;
    dataRooms: {
      __typename: 'DataRooms';
      count: number;
      objects: Array<{
        __typename: 'CedantDetails';
        id: string;
        cedant: string;
        name: string;
      }>;
    };
  }>;
};



export type FileBrowserFileFragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  path: string;
  parentDirectoryId: string;
  size: number;
  updatedAt: string;
  createdAt?: string | null;
  status?: FileStatus | null;
  virusStatus?: VirusStatus | null;
  piiStatus?: PiiStatus | null;
  canDownload: boolean;
  canMove: boolean;
  contentType: string;
  breadcrumbs: Array<{
    __typename: 'Breadcrumb';
    name: string;
    directoryId?: string | null;
  }>;
  versions: Array<{ __typename: 'File'; id: string }>;
};

export type FileBrowserDirectoryFragment = {
  __typename: 'Directory';
  id: string;
  name: string;
  cedant: string;
  path: string;
  fileCount: number;
  directoryCount: number;
  canArchive: boolean;
};

type FileBrowserStorageObject_Directory_Fragment = {
  __typename: 'Directory';
  id: string;
  name: string;
  cedant: string;
  path: string;
  fileCount: number;
  directoryCount: number;
  canArchive: boolean;
};

type FileBrowserStorageObject_File_Fragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  path: string;
  parentDirectoryId: string;
  size: number;
  updatedAt: string;
  createdAt?: string | null;
  status?: FileStatus | null;
  virusStatus?: VirusStatus | null;
  piiStatus?: PiiStatus | null;
  canDownload: boolean;
  canMove: boolean;
  contentType: string;
  breadcrumbs: Array<{
    __typename: 'Breadcrumb';
    name: string;
    directoryId?: string | null;
  }>;
  versions: Array<{ __typename: 'File'; id: string }>;
};

export type FileBrowserStorageObjectFragment =
  | FileBrowserStorageObject_Directory_Fragment
  | FileBrowserStorageObject_File_Fragment;

export type BreadcrumbFragment = {
  __typename: 'Breadcrumb';
  name: string;
  directoryId?: string | null;
};

export type GetDirectoryQueryVariables = Exact<{
  cedant: Scalars['String'];
  directoryId?: InputMaybe<Scalars['ID']>;
  objectsPagination?: InputMaybe<Pagination>;
}>;

export type GetDirectoryQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    name: string;
    canCreate: boolean;
    directory: {
      __typename: 'Directory';
      id: string;
      path: string;
      breadcrumbs: Array<{
        __typename: 'Breadcrumb';
        name: string;
        directoryId?: string | null;
      }>;
      objects: {
        __typename: 'StorageObjects';
        count: number;
        objects: Array<
          | {
              __typename: 'Directory';
              id: string;
              name: string;
              cedant: string;
              path: string;
              fileCount: number;
              directoryCount: number;
              canArchive: boolean;
            }
          | {
              __typename: 'File';
              id: string;
              name: string;
              cedant: string;
              path: string;
              parentDirectoryId: string;
              size: number;
              updatedAt: string;
              createdAt?: string | null;
              status?: FileStatus | null;
              virusStatus?: VirusStatus | null;
              piiStatus?: PiiStatus | null;
              canDownload: boolean;
              canMove: boolean;
              contentType: string;
              breadcrumbs: Array<{
                __typename: 'Breadcrumb';
                name: string;
                directoryId?: string | null;
              }>;
              versions: Array<{ __typename: 'File'; id: string }>;
            }
        >;
      };
    };
  } | null;
};

export type PiiApprovalFragment = {
  __typename: 'PIIApproval';
  comment: string;
  approvedAt: string;
  approver: { __typename: 'User'; name?: string | null; email?: string | null };
};

export type PiiMatchFragment = {
  __typename: 'PIIMatch';
  count: number;
  infoType: { __typename: 'PIIInfo'; type: PiiInfoType; label: string };
};

export type FileProcessErrorsFragment = {
  __typename: 'FileProcessErrors';
  count: number;
  errors: Array<{
    __typename: 'FileProcessError';
    code: FileProcessErrorCode;
    message?: string | null;
  }>;
};

export type GenericFileProcessFragment = {
  __typename: 'GenericFileProcess';
  name: string;
  status: FileProcessStatus;
  errors?: {
    __typename: 'FileProcessErrors';
    count: number;
    errors: Array<{
      __typename: 'FileProcessError';
      code: FileProcessErrorCode;
      message?: string | null;
    }>;
  } | null;
};

export type PiiFileProcessFragment = {
  __typename: 'PIIFileProcess';
  name: string;
  piiStatus: PiiStatus;
  errors?: {
    __typename: 'FileProcessErrors';
    count: number;
    errors: Array<{
      __typename: 'FileProcessError';
      code: FileProcessErrorCode;
      message?: string | null;
    }>;
  } | null;
};

export type AvFileProcessFragment = {
  __typename: 'AVFileProcess';
  name: string;
  virusStatus: VirusStatus;
  errors?: {
    __typename: 'FileProcessErrors';
    count: number;
    errors: Array<{
      __typename: 'FileProcessError';
      code: FileProcessErrorCode;
      message?: string | null;
    }>;
  } | null;
};

export type FileDetailsFileFragment = {
  __typename: 'File';
  id: string;
  name: string;
  cedant: string;
  contentType: string;
  path: string;
  parentDirectoryId: string;
  size: number;
  createdAt?: string | null;
  updatedAt: string;
  status?: FileStatus | null;
  virusStatus?: VirusStatus | null;
  piiStatus?: PiiStatus | null;
  version?: string | null;
  canArchive: boolean;
  canDelete: boolean;
  canDownload: boolean;
  canPiiJustify: boolean;
  canPiiApprove: boolean;
  canRename: boolean;
  canMove: boolean;
  canRetryProcesses: boolean;
  automatedUpload: boolean;
  breadcrumbs: Array<{
    __typename: 'Breadcrumb';
    name: string;
    directoryId?: string | null;
  }>;
  createdBy?: {
    __typename: 'User';
    email?: string | null;
    id: string;
    name?: string | null;
  } | null;
  versions: Array<{
    __typename: 'File';
    id: string;
    updatedBy?: { __typename: 'User'; name?: string | null } | null;
  }>;
  transformation?: {
    __typename: 'Transformation';
    transformedAt?: string | null;
    errors?: {
      __typename: 'TransformationErrors';
      code: TransformationErrorCode;
      messages: Array<{
        __typename: 'ErrorMessage';
        raw: string;
        column?: string | null;
        row?: number | null;
        value?: string | null;
        errType?: string | null;
      }>;
    } | null;
  } | null;
  piiDetails?: {
    __typename: 'PIIDetails';
    approvals: Array<{
      __typename: 'PIIApproval';
      comment: string;
      approvedAt: string;
      approver: {
        __typename: 'User';
        name?: string | null;
        email?: string | null;
      };
    }>;
    matches: Array<{
      __typename: 'PIIMatch';
      count: number;
      infoType: { __typename: 'PIIInfo'; type: PiiInfoType; label: string };
    }>;
  } | null;
  processes: Array<
    | {
        __typename: 'AVFileProcess';
        name: string;
        virusStatus: VirusStatus;
        errors?: {
          __typename: 'FileProcessErrors';
          count: number;
          errors: Array<{
            __typename: 'FileProcessError';
            code: FileProcessErrorCode;
            message?: string | null;
          }>;
        } | null;
      }
    | {
        __typename: 'GenericFileProcess';
        name: string;
        status: FileProcessStatus;
        errors?: {
          __typename: 'FileProcessErrors';
          count: number;
          errors: Array<{
            __typename: 'FileProcessError';
            code: FileProcessErrorCode;
            message?: string | null;
          }>;
        } | null;
      }
    | {
        __typename: 'PIIFileProcess';
        name: string;
        piiStatus: PiiStatus;
        errors?: {
          __typename: 'FileProcessErrors';
          count: number;
          errors: Array<{
            __typename: 'FileProcessError';
            code: FileProcessErrorCode;
            message?: string | null;
          }>;
        } | null;
      }
  >;
};

export type GetFileQueryVariables = Exact<{
  cedant: Scalars['String'];
  fileId: Scalars['ID'];
  errorsPagination?: InputMaybe<Pagination>;
}>;

export type GetFileQuery = {
  __typename: 'Query';
  cedant?: {
    __typename: 'CedantDetails';
    id: string;
    name: string;
    file: {
      __typename: 'File';
      id: string;
      name: string;
      cedant: string;
      contentType: string;
      path: string;
      parentDirectoryId: string;
      size: number;
      createdAt?: string | null;
      updatedAt: string;
      status?: FileStatus | null;
      virusStatus?: VirusStatus | null;
      piiStatus?: PiiStatus | null;
      version?: string | null;
      canArchive: boolean;
      canDelete: boolean;
      canDownload: boolean;
      canPiiJustify: boolean;
      canPiiApprove: boolean;
      canRename: boolean;
      canMove: boolean;
      canRetryProcesses: boolean;
      automatedUpload: boolean;
      breadcrumbs: Array<{
        __typename: 'Breadcrumb';
        name: string;
        directoryId?: string | null;
      }>;
      createdBy?: {
        __typename: 'User';
        email?: string | null;
        id: string;
        name?: string | null;
      } | null;
      versions: Array<{
        __typename: 'File';
        id: string;
        updatedBy?: { __typename: 'User'; name?: string | null } | null;
      }>;
      transformation?: {
        __typename: 'Transformation';
        transformedAt?: string | null;
        errors?: {
          __typename: 'TransformationErrors';
          code: TransformationErrorCode;
          messages: Array<{
            __typename: 'ErrorMessage';
            raw: string;
            column?: string | null;
            row?: number | null;
            value?: string | null;
            errType?: string | null;
          }>;
        } | null;
      } | null;
      piiDetails?: {
        __typename: 'PIIDetails';
        approvals: Array<{
          __typename: 'PIIApproval';
          comment: string;
          approvedAt: string;
          approver: {
            __typename: 'User';
            name?: string | null;
            email?: string | null;
          };
        }>;
        matches: Array<{
          __typename: 'PIIMatch';
          count: number;
          infoType: { __typename: 'PIIInfo'; type: PiiInfoType; label: string };
        }>;
      } | null;
      processes: Array<
        | {
            __typename: 'AVFileProcess';
            name: string;
            virusStatus: VirusStatus;
            errors?: {
              __typename: 'FileProcessErrors';
              count: number;
              errors: Array<{
                __typename: 'FileProcessError';
                code: FileProcessErrorCode;
                message?: string | null;
              }>;
            } | null;
          }
        | {
            __typename: 'GenericFileProcess';
            name: string;
            status: FileProcessStatus;
            errors?: {
              __typename: 'FileProcessErrors';
              count: number;
              errors: Array<{
                __typename: 'FileProcessError';
                code: FileProcessErrorCode;
                message?: string | null;
              }>;
            } | null;
          }
        | {
            __typename: 'PIIFileProcess';
            name: string;
            piiStatus: PiiStatus;
            errors?: {
              __typename: 'FileProcessErrors';
              count: number;
              errors: Array<{
                __typename: 'FileProcessError';
                code: FileProcessErrorCode;
                message?: string | null;
              }>;
            } | null; 
          }
      >;

    };
  } | null;
};

export type ProblemFilesFragment = {
  __typename: 'File';
  id: string;
  name: string;
  createdAt?: string | null;
  updatedAt: string;
  cedant: string;
  path: string;
  contentType: string;
  size: number;
};

export type GetProblemFilesQueryVariables = Exact<{
  cedants?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetProblemFilesQuery = {
  __typename: 'Query';
  problematicFiles: {
    __typename: 'ProblematicFilesObject';
    allowedDataRooms: Array<{
      __typename: 'CedantDetails';
      id: string;
      cedant: string;
      name: string;
    }>;
    problematicFiles: Array<{
      __typename: 'ProblematicFiles';
      problemType: string;
      problemDescription: string;
      count: number;
      files: Array<{
        __typename: 'File';
        id: string;
        name: string;
        createdAt?: string | null;
        updatedAt: string;
        cedant: string;
        path: string;
        contentType: string;
        size: number;
      }>;
    }>;
  };
};

export type TreatyUserFragment = {
  __typename: 'TreatyUser';
  id: string;
  canBlock: boolean;
  createdAt: string;
  email: string;
  emailNotifications: Array<string>;
  isBlocked: boolean;
  lastLogin?: string | null;
  loginCount: number;
  name: string;
  roles: Array<string>;
  type: UserType;
};

export type TreatyDetailsFragment = {
  __typename: 'CedantDetails';
  id: string;
  cedant: string;
  name: string;
};

export type RoleFragment = {
  __typename: 'Role';
  id: string;
  rawPermissions: string;
};

export type GetUserManagementDataQueryVariables = Exact<{
  searchParams: TreatyUsersSearch;
}>;

export type GetUserManagementDataQuery = {
  __typename: 'Query';
  treatyUsers: {
    __typename: 'TreatyUsers';
    count: number;
    users: Array<{
      __typename: 'TreatyUser';
      id: string;
      canBlock: boolean;
      createdAt: string;
      email: string;
      emailNotifications: Array<string>;
      isBlocked: boolean;
      lastLogin?: string | null;
      loginCount: number;
      name: string;
      roles: Array<string>;
      type: UserType;
    }>;
  };
  dataRoomCategories: Array<{
    __typename: 'DataRoomCategory';
    dataRooms: {
      __typename: 'DataRooms';
      objects: Array<{
        __typename: 'CedantDetails';
        id: string;
        cedant: string;
        name: string;
      }>;
    };
  }>;
  roles: Array<{ __typename: 'Role'; id: string; rawPermissions: string }>;
};

export const EventFileFragmentDoc = gql`
  fragment EventFile on File {
    id
    name
    path
    parentDirectoryId
  }
`;
export const EventDirectoryFragmentDoc = gql`
  fragment EventDirectory on Directory {
    id
    name
    path
    parentDirectoryId
  }
`;
export const EventFragmentDoc = gql`
  fragment Event on Event {
    id
    type
    user {
      id
      email
      name
    }
    timestamp
    path
    storageObject {
      ...EventFile
      ...EventDirectory
    }
  }
  ${EventFileFragmentDoc}
  ${EventDirectoryFragmentDoc}
`;
export const EventsResponseFragmentDoc = gql`
  fragment EventsResponse on EventsResponse {
    events {
      ...Event
    }
    hasMore
  }
  ${EventFragmentDoc}
`;
export const FileMoveFileFragmentDoc = gql`
  fragment FileMoveFile on File {
    id
    name
    cedant
    path
  }
`;
export const FileMoveDirectoryFragmentDoc = gql`
  fragment FileMoveDirectory on Directory {
    id
    name
    cedant
    path
  }
`;
export const MeFragmentDoc = gql`
  fragment Me on User {
    name
  }
`;
export const BreadcrumbFragmentDoc = gql`
  fragment Breadcrumb on Breadcrumb {
    name
    directoryId
  }
`;
export const VersionHistoryFileFieldsFragmentDoc = gql`
  fragment VersionHistoryFileFields on File {
    id
    name
    cedant
    path
    parentDirectoryId
    size
    updatedAt
    createdAt
    status
    piiStatus
    virusStatus
    version
    versions {
      id
    }
    breadcrumbs {
      ...Breadcrumb
    }
    createdBy {
      id
      name
    }
    updatedBy {
      id
      name
    }
    canDownload
    canMove
    contentType
  }
  ${BreadcrumbFragmentDoc}
`;
export const FileVersionHistoryFragmentDoc = gql`
  fragment FileVersionHistory on File {
    ...VersionHistoryFileFields
    versions {
      ...VersionHistoryFileFields
    }
  }
  ${VersionHistoryFileFieldsFragmentDoc}
`;
export const TreatyUserFragmentDoc = gql`
  fragment TreatyUser on TreatyUser {
    id
    canBlock
    createdAt
    email
    emailNotifications
    isBlocked
    lastLogin
    loginCount
    name
    roles
    type
  }
`;
export const TreatyUserDetailFragmentDoc = gql`
  fragment TreatyUserDetail on TreatyUser {
    ...TreatyUser
    hasMFAEnabled
  }
  ${TreatyUserFragmentDoc}
`;
export const ValidatedFilenameErrorFragmentDoc = gql`
  fragment ValidatedFilenameError on ValidatedFilenameError {
    code
    suggestedFilename
    suggestedFilepath
  }
`;
export const ValidatedFilenameWarningFragmentDoc = gql`
  fragment ValidatedFilenameWarning on ValidatedFilenameWarning {
    code
    expectedPattern
    expectedPatterns
    message
  }
`;
export const ValidatedFilenameFragmentDoc = gql`
  fragment ValidatedFilename on ValidatedFilename {
    id
    filepath
    isValid
  }
`;
export const DataRoomObjectFragmentDoc = gql`
  fragment DataRoomObject on CedantDetails {
    id
    cedant
    name
  }
`;

export const FileBrowserFileFragmentDoc = gql`
  fragment FileBrowserFile on File {
    id
    name
    cedant
    path
    parentDirectoryId
    size
    updatedAt
    createdAt
    status
    virusStatus
    piiStatus
    breadcrumbs {
      ...Breadcrumb
    }
    canDownload
    canMove
    contentType
    versions {
      id
    }
  }
  ${BreadcrumbFragmentDoc}
`;
export const FileBrowserDirectoryFragmentDoc = gql`
  fragment FileBrowserDirectory on Directory {
    id
    name
    cedant
    path
    fileCount
    directoryCount
    canArchive
  }
`;
export const FileBrowserStorageObjectFragmentDoc = gql`
  fragment FileBrowserStorageObject on StorageObject {
    ...FileBrowserFile
    ...FileBrowserDirectory
  }
  ${FileBrowserFileFragmentDoc}
  ${FileBrowserDirectoryFragmentDoc}
`;
export const PiiApprovalFragmentDoc = gql`
  fragment PiiApproval on PIIApproval {
    approver {
      name
      email
    }
    comment
    approvedAt
  }
`;
export const PiiMatchFragmentDoc = gql`
  fragment PiiMatch on PIIMatch {
    infoType {
      type
      label
    }
    count
  }
`;
export const FileProcessErrorsFragmentDoc = gql`
  fragment FileProcessErrors on FileProcessErrors {
    errors {
      code
      message
    }
    count
  }
`;
export const GenericFileProcessFragmentDoc = gql`
  fragment GenericFileProcess on GenericFileProcess {
    name
    status
    errors(pagination: $errorsPagination) {
      ...FileProcessErrors
    }
  }
  ${FileProcessErrorsFragmentDoc}
`;
export const PiiFileProcessFragmentDoc = gql`
  fragment PIIFileProcess on PIIFileProcess {
    name
    piiStatus
    errors(pagination: $errorsPagination) {
      ...FileProcessErrors
    }
  }
  ${FileProcessErrorsFragmentDoc}
`;
export const AvFileProcessFragmentDoc = gql`
  fragment AVFileProcess on AVFileProcess {
    name
    virusStatus
    errors(pagination: $errorsPagination) {
      ...FileProcessErrors
    }
  }
  ${FileProcessErrorsFragmentDoc}
`;
export const FileDetailsFileFragmentDoc = gql`
  fragment FileDetailsFile on File {
    id
    name
    cedant
    contentType
    path
    parentDirectoryId
    size
    createdAt
    updatedAt
    status
    virusStatus
    piiStatus
    version
    breadcrumbs {
      ...Breadcrumb
    }
    createdBy {
      email
      id
      name
    }
    versions {
      id
      updatedBy {
        name
      }
    }
    transformation {
      transformedAt
      errors {
        code
        messages {
          raw
          column
          row
          value
          errType
        }
      }
    }
    piiDetails {
      approvals {
        ...PiiApproval
      }
      matches {
        ...PiiMatch
      }
    }
    processes {
      ...GenericFileProcess
      ...PIIFileProcess
      ...AVFileProcess
    }
    canArchive
    canDelete
    canDownload
    canPiiJustify
    canPiiApprove
    canRename
    canMove
    canRetryProcesses
    automatedUpload
  }
  ${BreadcrumbFragmentDoc}
  ${PiiApprovalFragmentDoc}
  ${PiiMatchFragmentDoc}
  ${GenericFileProcessFragmentDoc}
  ${PiiFileProcessFragmentDoc}
  ${AvFileProcessFragmentDoc}
`;
export const ProblemFilesFragmentDoc = gql`
  fragment ProblemFiles on File {
    id
    name
    createdAt
    updatedAt
    cedant
    path
    contentType
    size
  }
`;
export const TreatyDetailsFragmentDoc = gql`
  fragment TreatyDetails on CedantDetails {
    id
    cedant
    name
  }
`;
export const RoleFragmentDoc = gql`
  fragment Role on Role {
    id
    rawPermissions
  }
`;
export const AddUserDocument = gql`
  mutation AddUser($input: AddUserInput!) {
    addUser(input: $input) {
      id
      name
    }
  }
`;
export type AddUserMutationFn = Apollo.MutationFunction<
  AddUserMutation,
  AddUserMutationVariables
>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUserMutation,
    AddUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(
    AddUserDocument,
    options
  );
}
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<
  AddUserMutation,
  AddUserMutationVariables
>;
export const GetFileActivityEventsDocument = gql`
  query GetFileActivityEvents(
    $cedant: String!
    $eventTypes: [EventType!]
    $user: String
    $folder: String
    $file: String
    $search: String
    $pagination: CursorPagination
  ) {
    cedant(cedant: $cedant) {
      id
      name
      events(
        types: $eventTypes
        user: $user
        folder: $folder
        file: $file
        search: $search
        cursorPagination: $pagination
      ) {
        ...EventsResponse
      }
    }
  }
  ${EventsResponseFragmentDoc}
`;

/**
 * __useGetFileActivityEventsQuery__
 *
 * To run a query within a React component, call `useGetFileActivityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileActivityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileActivityEventsQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      eventTypes: // value for 'eventTypes'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFileActivityEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileActivityEventsQuery,
    GetFileActivityEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFileActivityEventsQuery,
    GetFileActivityEventsQueryVariables
  >(GetFileActivityEventsDocument, options);
}
export function useGetFileActivityEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileActivityEventsQuery,
    GetFileActivityEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFileActivityEventsQuery,
    GetFileActivityEventsQueryVariables
  >(GetFileActivityEventsDocument, options);
}
export type GetFileActivityEventsQueryHookResult = ReturnType<
  typeof useGetFileActivityEventsQuery
>;
export type GetFileActivityEventsLazyQueryHookResult = ReturnType<
  typeof useGetFileActivityEventsLazyQuery
>;
export type GetFileActivityEventsQueryResult = Apollo.QueryResult<
  GetFileActivityEventsQuery,
  GetFileActivityEventsQueryVariables
>;
export const GetActivityFilterOptionsDocument = gql`
  query GetActivityFilterOptions($cedant: String!) {
    cedant(cedant: $cedant) {
      id
      name
      activityFilterOptions {
        users {
          id
          name
        }
        paths
      }
    }
  }
`;

/**
 * __useGetActivityFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetActivityFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityFilterOptionsQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *   },
 * });
 */
export function useGetActivityFilterOptionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetActivityFilterOptionsQuery,
    GetActivityFilterOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetActivityFilterOptionsQuery,
    GetActivityFilterOptionsQueryVariables
  >(GetActivityFilterOptionsDocument, options);
}
export function useGetActivityFilterOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetActivityFilterOptionsQuery,
    GetActivityFilterOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetActivityFilterOptionsQuery,
    GetActivityFilterOptionsQueryVariables
  >(GetActivityFilterOptionsDocument, options);
}
export type GetActivityFilterOptionsQueryHookResult = ReturnType<
  typeof useGetActivityFilterOptionsQuery
>;
export type GetActivityFilterOptionsLazyQueryHookResult = ReturnType<
  typeof useGetActivityFilterOptionsLazyQuery
>;
export type GetActivityFilterOptionsQueryResult = Apollo.QueryResult<
  GetActivityFilterOptionsQuery,
  GetActivityFilterOptionsQueryVariables
>;
export const ArchiveDirectoryDocument = gql`
  mutation ArchiveDirectory($cedant: String!, $directoryId: ID!) {
    archiveDirectory(cedant: $cedant, directoryId: $directoryId)
  }
`;
export type ArchiveDirectoryMutationFn = Apollo.MutationFunction<
  ArchiveDirectoryMutation,
  ArchiveDirectoryMutationVariables
>;

/**
 * __useArchiveDirectoryMutation__
 *
 * To run a mutation, you first call `useArchiveDirectoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveDirectoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveDirectoryMutation, { data, loading, error }] = useArchiveDirectoryMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      directoryId: // value for 'directoryId'
 *   },
 * });
 */
export function useArchiveDirectoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveDirectoryMutation,
    ArchiveDirectoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveDirectoryMutation,
    ArchiveDirectoryMutationVariables
  >(ArchiveDirectoryDocument, options);
}
export type ArchiveDirectoryMutationHookResult = ReturnType<
  typeof useArchiveDirectoryMutation
>;
export type ArchiveDirectoryMutationResult = Apollo.MutationResult<ArchiveDirectoryMutation>;
export type ArchiveDirectoryMutationOptions = Apollo.BaseMutationOptions<
  ArchiveDirectoryMutation,
  ArchiveDirectoryMutationVariables
>;
export const ArchiveFileByIdDocument = gql`
  mutation ArchiveFileById($cedant: String!, $id: ID!) {
    archiveFileById(cedant: $cedant, id: $id) {
      id
      name
    }
  }
`;
export type ArchiveFileByIdMutationFn = Apollo.MutationFunction<
  ArchiveFileByIdMutation,
  ArchiveFileByIdMutationVariables
>;

/**
 * __useArchiveFileByIdMutation__
 *
 * To run a mutation, you first call `useArchiveFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFileByIdMutation, { data, loading, error }] = useArchiveFileByIdMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveFileByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveFileByIdMutation,
    ArchiveFileByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveFileByIdMutation,
    ArchiveFileByIdMutationVariables
  >(ArchiveFileByIdDocument, options);
}
export type ArchiveFileByIdMutationHookResult = ReturnType<
  typeof useArchiveFileByIdMutation
>;
export type ArchiveFileByIdMutationResult = Apollo.MutationResult<ArchiveFileByIdMutation>;
export type ArchiveFileByIdMutationOptions = Apollo.BaseMutationOptions<
  ArchiveFileByIdMutation,
  ArchiveFileByIdMutationVariables
>;
export const DeleteFileByIdDocument = gql`
  mutation DeleteFileById($cedant: String!, $id: ID!) {
    deleteFileById(cedant: $cedant, id: $id) {
      id
      name
    }
  }
`;
export type DeleteFileByIdMutationFn = Apollo.MutationFunction<
  DeleteFileByIdMutation,
  DeleteFileByIdMutationVariables
>;

/**
 * __useDeleteFileByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileByIdMutation, { data, loading, error }] = useDeleteFileByIdMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFileByIdMutation,
    DeleteFileByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFileByIdMutation,
    DeleteFileByIdMutationVariables
  >(DeleteFileByIdDocument, options);
}
export type DeleteFileByIdMutationHookResult = ReturnType<
  typeof useDeleteFileByIdMutation
>;
export type DeleteFileByIdMutationResult = Apollo.MutationResult<DeleteFileByIdMutation>;
export type DeleteFileByIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteFileByIdMutation,
  DeleteFileByIdMutationVariables
>;
export const MoveFileDocument = gql`
  mutation MoveFile($cedant: String!, $input: MoveFileInput!) {
    moveFile(cedant: $cedant, input: $input) {
      id
      cedant
      name
      path
    }
  }
`;
export type MoveFileMutationFn = Apollo.MutationFunction<
  MoveFileMutation,
  MoveFileMutationVariables
>;

/**
 * __useMoveFileMutation__
 *
 * To run a mutation, you first call `useMoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveFileMutation, { data, loading, error }] = useMoveFileMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MoveFileMutation,
    MoveFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MoveFileMutation, MoveFileMutationVariables>(
    MoveFileDocument,
    options
  );
}
export type MoveFileMutationHookResult = ReturnType<typeof useMoveFileMutation>;
export type MoveFileMutationResult = Apollo.MutationResult<MoveFileMutation>;
export type MoveFileMutationOptions = Apollo.BaseMutationOptions<
  MoveFileMutation,
  MoveFileMutationVariables
>;
export const GetFileMoveDirectoryDocument = gql`
  query GetFileMoveDirectory(
    $cedant: String!
    $directoryId: ID
    $objectsPagination: Pagination
  ) {
    cedant(cedant: $cedant) {
      id
      name
      directory(id: $directoryId) {
        ...FileMoveDirectory
        breadcrumbs {
          ...Breadcrumb
        }
        objects(pagination: $objectsPagination) {
          objects {
            ...FileMoveFile
            ...FileMoveDirectory
          }
        }
      }
    }
  }
  ${FileMoveDirectoryFragmentDoc}
  ${BreadcrumbFragmentDoc}
  ${FileMoveFileFragmentDoc}
`;

/**
 * __useGetFileMoveDirectoryQuery__
 *
 * To run a query within a React component, call `useGetFileMoveDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileMoveDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileMoveDirectoryQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      directoryId: // value for 'directoryId'
 *      objectsPagination: // value for 'objectsPagination'
 *   },
 * });
 */
export function useGetFileMoveDirectoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileMoveDirectoryQuery,
    GetFileMoveDirectoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFileMoveDirectoryQuery,
    GetFileMoveDirectoryQueryVariables
  >(GetFileMoveDirectoryDocument, options);
}
export function useGetFileMoveDirectoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileMoveDirectoryQuery,
    GetFileMoveDirectoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFileMoveDirectoryQuery,
    GetFileMoveDirectoryQueryVariables
  >(GetFileMoveDirectoryDocument, options);
}
export type GetFileMoveDirectoryQueryHookResult = ReturnType<
  typeof useGetFileMoveDirectoryQuery
>;
export type GetFileMoveDirectoryLazyQueryHookResult = ReturnType<
  typeof useGetFileMoveDirectoryLazyQuery
>;
export type GetFileMoveDirectoryQueryResult = Apollo.QueryResult<
  GetFileMoveDirectoryQuery,
  GetFileMoveDirectoryQueryVariables
>;
export const RenameFileDocument = gql`
  mutation RenameFile($cedant: String!, $input: RenameFileInput!) {
    renameFile(cedant: $cedant, input: $input) {
      id
      cedant
      name
      path
    }
  }
`;
export type RenameFileMutationFn = Apollo.MutationFunction<
  RenameFileMutation,
  RenameFileMutationVariables
>;

/**
 * __useRenameFileMutation__
 *
 * To run a mutation, you first call `useRenameFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFileMutation, { data, loading, error }] = useRenameFileMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameFileMutation,
    RenameFileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenameFileMutation, RenameFileMutationVariables>(
    RenameFileDocument,
    options
  );
}
export type RenameFileMutationHookResult = ReturnType<
  typeof useRenameFileMutation
>;
export type RenameFileMutationResult = Apollo.MutationResult<RenameFileMutation>;
export type RenameFileMutationOptions = Apollo.BaseMutationOptions<
  RenameFileMutation,
  RenameFileMutationVariables
>;
export const PiiApproveByIdDocument = gql`
  mutation PiiApproveById($cedant: String!, $input: ApprovalInputById!) {
    piiApproveById(cedant: $cedant, input: $input) {
      id
      status
      piiStatus
      piiDetails {
        approvals {
          approver {
            name
          }
        }
      }
    }
  }
`;
export type PiiApproveByIdMutationFn = Apollo.MutationFunction<
  PiiApproveByIdMutation,
  PiiApproveByIdMutationVariables
>;

/**
 * __usePiiApproveByIdMutation__
 *
 * To run a mutation, you first call `usePiiApproveByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePiiApproveByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [piiApproveByIdMutation, { data, loading, error }] = usePiiApproveByIdMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePiiApproveByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PiiApproveByIdMutation,
    PiiApproveByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PiiApproveByIdMutation,
    PiiApproveByIdMutationVariables
  >(PiiApproveByIdDocument, options);
}
export type PiiApproveByIdMutationHookResult = ReturnType<
  typeof usePiiApproveByIdMutation
>;
export type PiiApproveByIdMutationResult = Apollo.MutationResult<PiiApproveByIdMutation>;
export type PiiApproveByIdMutationOptions = Apollo.BaseMutationOptions<
  PiiApproveByIdMutation,
  PiiApproveByIdMutationVariables
>;
export const PiiJustifyByIdDocument = gql`
  mutation PiiJustifyById($cedant: String!, $input: ApprovalInputById!) {
    piiJustifyById(cedant: $cedant, input: $input) {
      id
      status
      piiStatus
      piiDetails {
        approvals {
          approver {
            name
          }
        }
      }
    }
  }
`;
export type PiiJustifyByIdMutationFn = Apollo.MutationFunction<
  PiiJustifyByIdMutation,
  PiiJustifyByIdMutationVariables
>;

/**
 * __usePiiJustifyByIdMutation__
 *
 * To run a mutation, you first call `usePiiJustifyByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePiiJustifyByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [piiJustifyByIdMutation, { data, loading, error }] = usePiiJustifyByIdMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePiiJustifyByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PiiJustifyByIdMutation,
    PiiJustifyByIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PiiJustifyByIdMutation,
    PiiJustifyByIdMutationVariables
  >(PiiJustifyByIdDocument, options);
}
export type PiiJustifyByIdMutationHookResult = ReturnType<
  typeof usePiiJustifyByIdMutation
>;
export type PiiJustifyByIdMutationResult = Apollo.MutationResult<PiiJustifyByIdMutation>;
export type PiiJustifyByIdMutationOptions = Apollo.BaseMutationOptions<
  PiiJustifyByIdMutation,
  PiiJustifyByIdMutationVariables
>;
export const DownloadFileDocument = gql`
  query DownloadFile($cedant: String!, $fileId: ID!) {
    cedant(cedant: $cedant) {
      id
      signedUrl: downloadFile(id: $fileId)
    }
  }
`;

/**
 * __useDownloadFileQuery__
 *
 * To run a query within a React component, call `useDownloadFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFileQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDownloadFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    DownloadFileQuery,
    DownloadFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownloadFileQuery, DownloadFileQueryVariables>(
    DownloadFileDocument,
    options
  );
}
export function useDownloadFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadFileQuery,
    DownloadFileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DownloadFileQuery, DownloadFileQueryVariables>(
    DownloadFileDocument,
    options
  );
}
export type DownloadFileQueryHookResult = ReturnType<
  typeof useDownloadFileQuery
>;
export type DownloadFileLazyQueryHookResult = ReturnType<
  typeof useDownloadFileLazyQuery
>;
export type DownloadFileQueryResult = Apollo.QueryResult<
  DownloadFileQuery,
  DownloadFileQueryVariables
>;
export const GetMeDocument = gql`
  query GetMe {
    me {
      ...Me
    }
  }
  ${MeFragmentDoc}
`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export function useGetMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(
    GetMeDocument,
    options
  );
}
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<
  GetMeQuery,
  GetMeQueryVariables
>;
export const RetryFileProcessesDocument = gql`
  mutation RetryFileProcesses($fileId: ID!) {
    retryFileProcesses(fileId: $fileId)
  }
`;
export type RetryFileProcessesMutationFn = Apollo.MutationFunction<
  RetryFileProcessesMutation,
  RetryFileProcessesMutationVariables
>;

/**
 * __useRetryFileProcessesMutation__
 *
 * To run a mutation, you first call `useRetryFileProcessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFileProcessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFileProcessesMutation, { data, loading, error }] = useRetryFileProcessesMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRetryFileProcessesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryFileProcessesMutation,
    RetryFileProcessesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryFileProcessesMutation,
    RetryFileProcessesMutationVariables
  >(RetryFileProcessesDocument, options);
}
export type RetryFileProcessesMutationHookResult = ReturnType<
  typeof useRetryFileProcessesMutation
>;
export type RetryFileProcessesMutationResult = Apollo.MutationResult<RetryFileProcessesMutation>;
export type RetryFileProcessesMutationOptions = Apollo.BaseMutationOptions<
  RetryFileProcessesMutation,
  RetryFileProcessesMutationVariables
>;
export const DownloadFileVersionDocument = gql`
  query DownloadFileVersion($cedant: String!, $fileId: ID!, $version: String) {
    cedant(cedant: $cedant) {
      id
      signedUrl: downloadFile(id: $fileId, version: $version)
    }
  }
`;

/**
 * __useDownloadFileVersionQuery__
 *
 * To run a query within a React component, call `useDownloadFileVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFileVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFileVersionQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      fileId: // value for 'fileId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDownloadFileVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    DownloadFileVersionQuery,
    DownloadFileVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadFileVersionQuery,
    DownloadFileVersionQueryVariables
  >(DownloadFileVersionDocument, options);
}
export function useDownloadFileVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadFileVersionQuery,
    DownloadFileVersionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadFileVersionQuery,
    DownloadFileVersionQueryVariables
  >(DownloadFileVersionDocument, options);
}
export type DownloadFileVersionQueryHookResult = ReturnType<
  typeof useDownloadFileVersionQuery
>;
export type DownloadFileVersionLazyQueryHookResult = ReturnType<
  typeof useDownloadFileVersionLazyQuery
>;
export type DownloadFileVersionQueryResult = Apollo.QueryResult<
  DownloadFileVersionQuery,
  DownloadFileVersionQueryVariables
>;
export const GetFileVersionHistoryDocument = gql`
  query GetFileVersionHistory($cedant: String!, $fileId: ID!) {
    cedant(cedant: $cedant) {
      id
      file: fileById(id: $fileId) {
        ...FileVersionHistory
      }
    }
  }
  ${FileVersionHistoryFragmentDoc}
`;

/**
 * __useGetFileVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetFileVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileVersionHistoryQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileVersionHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileVersionHistoryQuery,
    GetFileVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFileVersionHistoryQuery,
    GetFileVersionHistoryQueryVariables
  >(GetFileVersionHistoryDocument, options);
}
export function useGetFileVersionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileVersionHistoryQuery,
    GetFileVersionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFileVersionHistoryQuery,
    GetFileVersionHistoryQueryVariables
  >(GetFileVersionHistoryDocument, options);
}
export type GetFileVersionHistoryQueryHookResult = ReturnType<
  typeof useGetFileVersionHistoryQuery
>;
export type GetFileVersionHistoryLazyQueryHookResult = ReturnType<
  typeof useGetFileVersionHistoryLazyQuery
>;
export type GetFileVersionHistoryQueryResult = Apollo.QueryResult<
  GetFileVersionHistoryQuery,
  GetFileVersionHistoryQueryVariables
>;
export const GetSearchResultsDocument = gql`
  query GetSearchResults(
    $cedants: [String!]
    $term: String!
    $pagination: Pagination
    $from: Time
    $to: Time
  ) {
    search(
      cedants: $cedants
      term: $term
      pagination: $pagination
      from: $from
      to: $to
    ) {
      count
      objects {
        ...FileBrowserStorageObject
      }
    }
  }
  ${FileBrowserStorageObjectFragmentDoc}
`;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      cedants: // value for 'cedants'
 *      term: // value for 'term'
 *      pagination: // value for 'pagination'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetSearchResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(
    GetSearchResultsDocument,
    options
  );
}
export function useGetSearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSearchResultsQuery,
    GetSearchResultsQueryVariables
  >(GetSearchResultsDocument, options);
}
export type GetSearchResultsQueryHookResult = ReturnType<
  typeof useGetSearchResultsQuery
>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<
  typeof useGetSearchResultsLazyQuery
>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<
  GetSearchResultsQuery,
  GetSearchResultsQueryVariables
>;
export const ResetMfaDocument = gql`
  mutation ResetMFA($userId: String!) {
    resetMFA(userId: $userId)
  }
`;
export type ResetMfaMutationFn = Apollo.MutationFunction<
  ResetMfaMutation,
  ResetMfaMutationVariables
>;

/**
 * __useResetMfaMutation__
 *
 * To run a mutation, you first call `useResetMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetMfaMutation, { data, loading, error }] = useResetMfaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResetMfaMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetMfaMutation,
    ResetMfaMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetMfaMutation, ResetMfaMutationVariables>(
    ResetMfaDocument,
    options
  );
}
export type ResetMfaMutationHookResult = ReturnType<typeof useResetMfaMutation>;
export type ResetMfaMutationResult = Apollo.MutationResult<ResetMfaMutation>;
export type ResetMfaMutationOptions = Apollo.BaseMutationOptions<
  ResetMfaMutation,
  ResetMfaMutationVariables
>;
export const UpdateUserEmailNotificationsDocument = gql`
  mutation UpdateUserEmailNotifications(
    $input: UpdateUserEmailNotificationsInput!
  ) {
    updateUserEmailNotifications(input: $input)
  }
`;
export type UpdateUserEmailNotificationsMutationFn = Apollo.MutationFunction<
  UpdateUserEmailNotificationsMutation,
  UpdateUserEmailNotificationsMutationVariables
>;

/**
 * __useUpdateUserEmailNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateUserEmailNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserEmailNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserEmailNotificationsMutation, { data, loading, error }] = useUpdateUserEmailNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserEmailNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserEmailNotificationsMutation,
    UpdateUserEmailNotificationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserEmailNotificationsMutation,
    UpdateUserEmailNotificationsMutationVariables
  >(UpdateUserEmailNotificationsDocument, options);
}
export type UpdateUserEmailNotificationsMutationHookResult = ReturnType<
  typeof useUpdateUserEmailNotificationsMutation
>;
export type UpdateUserEmailNotificationsMutationResult = Apollo.MutationResult<UpdateUserEmailNotificationsMutation>;
export type UpdateUserEmailNotificationsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserEmailNotificationsMutation,
  UpdateUserEmailNotificationsMutationVariables
>;
export const UpdateUserRolesDocument = gql`
  mutation UpdateUserRoles($input: UpdateUserRolesInput!) {
    updateUserRoles(input: $input)
  }
`;
export type UpdateUserRolesMutationFn = Apollo.MutationFunction<
  UpdateUserRolesMutation,
  UpdateUserRolesMutationVariables
>;

/**
 * __useUpdateUserRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRolesMutation, { data, loading, error }] = useUpdateUserRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserRolesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserRolesMutation,
    UpdateUserRolesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserRolesMutation,
    UpdateUserRolesMutationVariables
  >(UpdateUserRolesDocument, options);
}
export type UpdateUserRolesMutationHookResult = ReturnType<
  typeof useUpdateUserRolesMutation
>;
export type UpdateUserRolesMutationResult = Apollo.MutationResult<UpdateUserRolesMutation>;
export type UpdateUserRolesMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRolesMutation,
  UpdateUserRolesMutationVariables
>;
export const GetTreatyUserDocument = gql`
  query GetTreatyUser($id: String!) {
    treatyUser(id: $id) {
      ...TreatyUserDetail
    }
  }
  ${TreatyUserDetailFragmentDoc}
`;

/**
 * __useGetTreatyUserQuery__
 *
 * To run a query within a React component, call `useGetTreatyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatyUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTreatyUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTreatyUserQuery,
    GetTreatyUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTreatyUserQuery, GetTreatyUserQueryVariables>(
    GetTreatyUserDocument,
    options
  );
}
export function useGetTreatyUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTreatyUserQuery,
    GetTreatyUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTreatyUserQuery, GetTreatyUserQueryVariables>(
    GetTreatyUserDocument,
    options
  );
}
export type GetTreatyUserQueryHookResult = ReturnType<
  typeof useGetTreatyUserQuery
>;
export type GetTreatyUserLazyQueryHookResult = ReturnType<
  typeof useGetTreatyUserLazyQuery
>;
export type GetTreatyUserQueryResult = Apollo.QueryResult<
  GetTreatyUserQuery,
  GetTreatyUserQueryVariables
>;
export const BlockUserDocument = gql`
  mutation BlockUser($userId: String!) {
    blockUser(userId: $userId)
  }
`;
export type BlockUserMutationFn = Apollo.MutationFunction<
  BlockUserMutation,
  BlockUserMutationVariables
>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockUserMutation,
    BlockUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(
    BlockUserDocument,
    options
  );
}
export type BlockUserMutationHookResult = ReturnType<
  typeof useBlockUserMutation
>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<
  BlockUserMutation,
  BlockUserMutationVariables
>;
export const UnblockUserDocument = gql`
  mutation UnblockUser($userId: String!) {
    unblockUser(userId: $userId)
  }
`;
export type UnblockUserMutationFn = Apollo.MutationFunction<
  UnblockUserMutation,
  UnblockUserMutationVariables
>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnblockUserMutation,
    UnblockUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(
    UnblockUserDocument,
    options
  );
}
export type UnblockUserMutationHookResult = ReturnType<
  typeof useUnblockUserMutation
>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<
  UnblockUserMutation,
  UnblockUserMutationVariables
>;
export const CreateFolderDocument = gql`
  mutation CreateFolder($cedant: String!, $input: CreateFolderInput!) {
    createFolder(cedant: $cedant, input: $input) {
      ...FileBrowserDirectory
    }
  }
  ${FileBrowserDirectoryFragmentDoc}
`;
export type CreateFolderMutationFn = Apollo.MutationFunction<
  CreateFolderMutation,
  CreateFolderMutationVariables
>;

/**
 * __useCreateFolderMutation__
 *
 * To run a mutation, you first call `useCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFolderMutation, { data, loading, error }] = useCreateFolderMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFolderMutation,
    CreateFolderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateFolderMutation,
    CreateFolderMutationVariables
  >(CreateFolderDocument, options);
}
export type CreateFolderMutationHookResult = ReturnType<
  typeof useCreateFolderMutation
>;
export type CreateFolderMutationResult = Apollo.MutationResult<CreateFolderMutation>;
export type CreateFolderMutationOptions = Apollo.BaseMutationOptions<
  CreateFolderMutation,
  CreateFolderMutationVariables
>;
export const UploadFileSignedUrlDocument = gql`
  mutation UploadFileSignedUrl(
    $cedant: String!
    $input: FileUploadSignedURLInput!
  ) {
    uploadFileSignedURL(cedant: $cedant, input: $input) {
      signedURL
      headers {
        key
        value
      }
    }
  }
`;
export type UploadFileSignedUrlMutationFn = Apollo.MutationFunction<
  UploadFileSignedUrlMutation,
  UploadFileSignedUrlMutationVariables
>;

/**
 * __useUploadFileSignedUrlMutation__
 *
 * To run a mutation, you first call `useUploadFileSignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileSignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileSignedUrlMutation, { data, loading, error }] = useUploadFileSignedUrlMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFileSignedUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadFileSignedUrlMutation,
    UploadFileSignedUrlMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadFileSignedUrlMutation,
    UploadFileSignedUrlMutationVariables
  >(UploadFileSignedUrlDocument, options);
}
export type UploadFileSignedUrlMutationHookResult = ReturnType<
  typeof useUploadFileSignedUrlMutation
>;
export type UploadFileSignedUrlMutationResult = Apollo.MutationResult<UploadFileSignedUrlMutation>;
export type UploadFileSignedUrlMutationOptions = Apollo.BaseMutationOptions<
  UploadFileSignedUrlMutation,
  UploadFileSignedUrlMutationVariables
>;
export const ValidateFilenamesDocument = gql`
  mutation ValidateFilenames(
    $cedant: String!
    $input: ValidateFilenamesInput!
  ) {
    validateFilenames(cedant: $cedant, input: $input) {
      ...ValidatedFilename
      errors {
        ...ValidatedFilenameError
      }
      warnings {
        ...ValidatedFilenameWarning
      }
    }
  }
  ${ValidatedFilenameFragmentDoc}
  ${ValidatedFilenameErrorFragmentDoc}
  ${ValidatedFilenameWarningFragmentDoc}
`;
export type ValidateFilenamesMutationFn = Apollo.MutationFunction<
  ValidateFilenamesMutation,
  ValidateFilenamesMutationVariables
>;

/**
 * __useValidateFilenamesMutation__
 *
 * To run a mutation, you first call `useValidateFilenamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFilenamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFilenamesMutation, { data, loading, error }] = useValidateFilenamesMutation({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateFilenamesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateFilenamesMutation,
    ValidateFilenamesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateFilenamesMutation,
    ValidateFilenamesMutationVariables
  >(ValidateFilenamesDocument, options);
}
export type ValidateFilenamesMutationHookResult = ReturnType<
  typeof useValidateFilenamesMutation
>;
export type ValidateFilenamesMutationResult = Apollo.MutationResult<ValidateFilenamesMutation>;
export type ValidateFilenamesMutationOptions = Apollo.BaseMutationOptions<
  ValidateFilenamesMutation,
  ValidateFilenamesMutationVariables
>;
export const GetAppConfigDocument = gql`
  query GetAppConfig {
    appConfig {
      canManageUsers
      canDownloadPiiReport
      canViewProblemFiles
    }
  }
`;

/**
 * __useGetAppConfigQuery__
 *
 * To run a query within a React component, call `useGetAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppConfigQuery,
    GetAppConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(
    GetAppConfigDocument,
    options
  );
}
export function useGetAppConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppConfigQuery,
    GetAppConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAppConfigQuery, GetAppConfigQueryVariables>(
    GetAppConfigDocument,
    options
  );
}
export type GetAppConfigQueryHookResult = ReturnType<
  typeof useGetAppConfigQuery
>;
export type GetAppConfigLazyQueryHookResult = ReturnType<
  typeof useGetAppConfigLazyQuery
>;
export type GetAppConfigQueryResult = Apollo.QueryResult<
  GetAppConfigQuery,
  GetAppConfigQueryVariables
>;
export const GetTreatyNameDocument = gql`
  query GetTreatyName($cedant: String!) {
    treaty: cedant(cedant: $cedant) {
      id
      name
    }
  }
`;

/**
 * __useGetTreatyNameQuery__
 *
 * To run a query within a React component, call `useGetTreatyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatyNameQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *   },
 * });
 */
export function useGetTreatyNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTreatyNameQuery,
    GetTreatyNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTreatyNameQuery, GetTreatyNameQueryVariables>(
    GetTreatyNameDocument,
    options
  );
}
export function useGetTreatyNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTreatyNameQuery,
    GetTreatyNameQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTreatyNameQuery, GetTreatyNameQueryVariables>(
    GetTreatyNameDocument,
    options
  );
}
export type GetTreatyNameQueryHookResult = ReturnType<
  typeof useGetTreatyNameQuery
>;
export type GetTreatyNameLazyQueryHookResult = ReturnType<
  typeof useGetTreatyNameLazyQuery
>;
export type GetTreatyNameQueryResult = Apollo.QueryResult<
  GetTreatyNameQuery,
  GetTreatyNameQueryVariables
>;
export const GetDataRoomsDocument = gql`
  query GetDataRooms {
    dataRoomCategories {
      id
      name
      dataRooms {
        count
        objects {
          ...DataRoomObject
        }
      }
    }
  }
  ${DataRoomObjectFragmentDoc}
`;

/**
 * __useGetDataRoomsQuery__
 *
 * To run a query within a React component, call `useGetDataRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataRoomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDataRoomsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDataRoomsQuery,
    GetDataRoomsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDataRoomsQuery, GetDataRoomsQueryVariables>(
    GetDataRoomsDocument,
    options
  );
}
export function useGetDataRoomsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataRoomsQuery,
    GetDataRoomsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDataRoomsQuery, GetDataRoomsQueryVariables>(
    GetDataRoomsDocument,
    options
  );
}
export type GetDataRoomsQueryHookResult = ReturnType<
  typeof useGetDataRoomsQuery
>;
export type GetDataRoomsLazyQueryHookResult = ReturnType<
  typeof useGetDataRoomsLazyQuery
>;
export type GetDataRoomsQueryResult = Apollo.QueryResult<
  GetDataRoomsQuery,
  GetDataRoomsQueryVariables
>;

export const GetDirectoryDocument = gql`
  query GetDirectory(
    $cedant: String!
    $directoryId: ID
    $objectsPagination: Pagination
  ) {
    cedant(cedant: $cedant) {
      id
      name
      directory(id: $directoryId) {
        id
        breadcrumbs {
          ...Breadcrumb
        }
        objects(pagination: $objectsPagination) {
          objects {
            ...FileBrowserStorageObject
          }
          count
        }
        path
      }
      canCreate
    }
  }
  ${BreadcrumbFragmentDoc}
  ${FileBrowserStorageObjectFragmentDoc}
`;

/**
 * __useGetDirectoryQuery__
 *
 * To run a query within a React component, call `useGetDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectoryQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      directoryId: // value for 'directoryId'
 *      objectsPagination: // value for 'objectsPagination'
 *   },
 * });
 */
export function useGetDirectoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDirectoryQuery,
    GetDirectoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDirectoryQuery, GetDirectoryQueryVariables>(
    GetDirectoryDocument,
    options
  );
}
export function useGetDirectoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDirectoryQuery,
    GetDirectoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDirectoryQuery, GetDirectoryQueryVariables>(
    GetDirectoryDocument,
    options
  );
}
export type GetDirectoryQueryHookResult = ReturnType<
  typeof useGetDirectoryQuery
>;
export type GetDirectoryLazyQueryHookResult = ReturnType<
  typeof useGetDirectoryLazyQuery
>;
export type GetDirectoryQueryResult = Apollo.QueryResult<
  GetDirectoryQuery,
  GetDirectoryQueryVariables
>;
export const GetFileDocument = gql`
  query GetFile($cedant: String!, $fileId: ID!, $errorsPagination: Pagination) {
    cedant(cedant: $cedant) {
      id
      name
      file: fileById(id: $fileId) {
        ...FileDetailsFile
      }
    }
  }
  ${FileDetailsFileFragmentDoc}
`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      cedant: // value for 'cedant'
 *      fileId: // value for 'fileId'
 *      errorsPagination: // value for 'errorsPagination'
 *   },
 * });
 */
export function useGetFileQuery(
  baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options
  );
}
export function useGetFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options
  );
}
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileQueryResult = Apollo.QueryResult<
  GetFileQuery,
  GetFileQueryVariables
>;
export const GetProblemFilesDocument = gql`
  query GetProblemFiles($cedants: [String!]) {
    problematicFiles(cedants: $cedants) {
      allowedDataRooms {
        ...DataRoomObject
      }
      problematicFiles {
        files {
          ...ProblemFiles
        }
        problemType
        problemDescription
        count
      }
    }
  }
  ${DataRoomObjectFragmentDoc}
  ${ProblemFilesFragmentDoc}
`;

/**
 * __useGetProblemFilesQuery__
 *
 * To run a query within a React component, call `useGetProblemFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProblemFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProblemFilesQuery({
 *   variables: {
 *      cedants: // value for 'cedants'
 *   },
 * });
 */
export function useGetProblemFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProblemFilesQuery,
    GetProblemFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProblemFilesQuery, GetProblemFilesQueryVariables>(
    GetProblemFilesDocument,
    options
  );
}
export function useGetProblemFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProblemFilesQuery,
    GetProblemFilesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProblemFilesQuery,
    GetProblemFilesQueryVariables
  >(GetProblemFilesDocument, options);
}
export type GetProblemFilesQueryHookResult = ReturnType<
  typeof useGetProblemFilesQuery
>;
export type GetProblemFilesLazyQueryHookResult = ReturnType<
  typeof useGetProblemFilesLazyQuery
>;
export type GetProblemFilesQueryResult = Apollo.QueryResult<
  GetProblemFilesQuery,
  GetProblemFilesQueryVariables
>;
export const GetUserManagementDataDocument = gql`
  query GetUserManagementData($searchParams: TreatyUsersSearch!) {
    treatyUsers(searchParams: $searchParams) {
      users {
        ...TreatyUser
      }
      count
    }
    dataRoomCategories {
      dataRooms {
        objects {
          ...TreatyDetails
        }
      }
    }
    roles {
      ...Role
    }
  }
  ${TreatyUserFragmentDoc}
  ${TreatyDetailsFragmentDoc}
  ${RoleFragmentDoc}
`;

/**
 * __useGetUserManagementDataQuery__
 *
 * To run a query within a React component, call `useGetUserManagementDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserManagementDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserManagementDataQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useGetUserManagementDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserManagementDataQuery,
    GetUserManagementDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserManagementDataQuery,
    GetUserManagementDataQueryVariables
  >(GetUserManagementDataDocument, options);
}
export function useGetUserManagementDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserManagementDataQuery,
    GetUserManagementDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserManagementDataQuery,
    GetUserManagementDataQueryVariables
  >(GetUserManagementDataDocument, options);
}
export type GetUserManagementDataQueryHookResult = ReturnType<
  typeof useGetUserManagementDataQuery
>;
export type GetUserManagementDataLazyQueryHookResult = ReturnType<
  typeof useGetUserManagementDataLazyQuery
>;
export type GetUserManagementDataQueryResult = Apollo.QueryResult<
  GetUserManagementDataQuery,
  GetUserManagementDataQueryVariables
>;

// OCT-7340: TreatyApp: User Management — add an Action History view of admin activity - Frontend : ashish.atwal@resolutionlife.com
// The declarations below are normally produced by `yarn gql:codegen` from the
// backend schema. Because the backend schema is not present in this repo, the
// ActionHistory operation output is added here by hand to match the codegen
// shape (types, fragment docs, document, and hooks). A future codegen run will
// regenerate/reorder these identically.

export type ActionHistoryFilter = {
  actionType?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['Time']>;
  pagination?: InputMaybe<Pagination>;
  to?: InputMaybe<Scalars['Time']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ActionHistoryEntry = {
  __typename: 'ActionHistoryEntry';
  actionType: Scalars['String'];
  actor: User;
  details: Scalars['String'];
  id: Scalars['ID'];
  timestamp: Scalars['Time'];
};

export type ActionHistoryResponse = {
  __typename: 'ActionHistoryResponse';
  count: Scalars['Int'];
  entries: Array<ActionHistoryEntry>;
};

export type ActionHistoryEntryFragment = {
  __typename: 'ActionHistoryEntry';
  actionType: string;
  details: string;
  id: string;
  timestamp: string;
  actor: {
    __typename: 'User';
    id: string;
    name?: string | null;
    email?: string | null;
  };
};

export type ActionHistoryResponseFragment = {
  __typename: 'ActionHistoryResponse';
  count: number;
  entries: Array<ActionHistoryEntryFragment>;
};

export type ActionHistoryQueryVariables = Exact<{
  filter?: InputMaybe<ActionHistoryFilter>;
}>;

export type ActionHistoryQuery = {
  __typename: 'Query';
  actionHistory: ActionHistoryResponseFragment;
};

export type ActionHistoryFilterOptions = {
  __typename: 'ActionHistoryFilterOptions';
  actionTypes: Array<Scalars['String']>;
  users: Array<FilterUserOption>;
};

export type FilterUserOption = {
  __typename: 'FilterUserOption';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ActionHistoryFilterOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ActionHistoryFilterOptionsQuery = {
  __typename: 'Query';
  actionHistoryFilterOptions: {
    __typename: 'ActionHistoryFilterOptions';
    actionTypes: Array<string>;
    users: Array<{
      __typename: 'FilterUserOption';
      id: string;
      name: string;
    }>;
  };
};

export const ActionHistoryEntryFragmentDoc = gql`
  fragment ActionHistoryEntry on ActionHistoryEntry {
    id
    timestamp
    actor {
      id
      name
      email
    }
    actionType
    details
  }
`;
export const ActionHistoryResponseFragmentDoc = gql`
  fragment ActionHistoryResponse on ActionHistoryResponse {
    entries {
      ...ActionHistoryEntry
    }
    count
  }
  ${ActionHistoryEntryFragmentDoc}
`;
export const ActionHistoryDocument = gql`
  query ActionHistory($filter: ActionHistoryFilter) {
    actionHistory(filter: $filter) {
      ...ActionHistoryResponse
    }
  }
  ${ActionHistoryResponseFragmentDoc}
`;

/**
 * __useActionHistoryQuery__
 *
 * To run a query within a React component, call `useActionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useActionHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActionHistoryQuery,
    ActionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActionHistoryQuery, ActionHistoryQueryVariables>(
    ActionHistoryDocument,
    options
  );
}
export function useActionHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActionHistoryQuery,
    ActionHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActionHistoryQuery, ActionHistoryQueryVariables>(
    ActionHistoryDocument,
    options
  );
}
export type ActionHistoryQueryHookResult = ReturnType<
  typeof useActionHistoryQuery
>;
export type ActionHistoryLazyQueryHookResult = ReturnType<
  typeof useActionHistoryLazyQuery
>;
export type ActionHistoryQueryResult = Apollo.QueryResult<
  ActionHistoryQuery,
  ActionHistoryQueryVariables
>;
export const ActionHistoryFilterOptionsDocument = gql`
  query ActionHistoryFilterOptions {
    actionHistoryFilterOptions {
      users {
        id
        name
      }
      actionTypes
    }
  }
`;

/**
 * __useActionHistoryFilterOptionsQuery__
 *
 * To run a query within a React component, call `useActionHistoryFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionHistoryFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionHistoryFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionHistoryFilterOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActionHistoryFilterOptionsQuery,
    ActionHistoryFilterOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActionHistoryFilterOptionsQuery,
    ActionHistoryFilterOptionsQueryVariables
  >(ActionHistoryFilterOptionsDocument, options);
}
export function useActionHistoryFilterOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActionHistoryFilterOptionsQuery,
    ActionHistoryFilterOptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActionHistoryFilterOptionsQuery,
    ActionHistoryFilterOptionsQueryVariables
  >(ActionHistoryFilterOptionsDocument, options);
}
export type ActionHistoryFilterOptionsQueryHookResult = ReturnType<
  typeof useActionHistoryFilterOptionsQuery
>;
export type ActionHistoryFilterOptionsLazyQueryHookResult = ReturnType<
  typeof useActionHistoryFilterOptionsLazyQuery
>;
export type ActionHistoryFilterOptionsQueryResult = Apollo.QueryResult<
  ActionHistoryFilterOptionsQuery,
  ActionHistoryFilterOptionsQueryVariables
>;
